import React from 'react';
import { Dialog } from 'ui';
import { Iframe } from './InAppPopup.styled';

const InAppPopup = ({ onClose, url, language }) => (
	<Dialog onClose={onClose}>
		<Dialog.Window width={788} padding={0}>
			<Iframe allow="fullscreen" src={url.replace('{lang}', language)} />
		</Dialog.Window>
	</Dialog>
);

export default InAppPopup;
